'use client';

import React, { useEffect, useState } from 'react';

import AppImage from './AppImage';
import { logoService } from '@/lib/services/logoService';

const STATIC_LOGO = '/assets/images/logo192x192-1771771688311-1773156106188.png';

interface AppLogoProps {
  src?: string;
  text?: string;
  iconName?: string;
  size?: number;
  className?: string;
  onClick?: () => void;
  priority?: boolean;
}

function AppLogo({
  src,
  text,
  iconName = 'SparklesIcon',
  size = 120,
  className = '',
  onClick,
  priority = false,
}: AppLogoProps) {
  // Start with the static local logo immediately — no spinner, no delay
  const [logoUrl, setLogoUrl] = useState<string>(src || STATIC_LOGO);

  useEffect(() => {
    // Only attempt Supabase fetch if no explicit src prop was passed
    if (!src) {
      logoService.getLogoUrl()
        .then((url) => {
          if (url) setLogoUrl(url);
        })
        .catch(() => {
          // Keep the static fallback already shown
        });
    }
  }, [src]);

  return (
    <div
      className={`flex items-center gap-2 ${onClick ? 'cursor-pointer hover:opacity-80' : ''} ${className}`}
      onClick={onClick}
    >
      <AppImage
        src={logoUrl}
        alt="GoGedit Logo"
        width={size}
        height={size}
        className="flex-shrink-0"
        priority={priority}
      />

      {text && <span className="text-xl font-bold">{text}</span>}
    </div>
  );
}

export default AppLogo;
